import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import Wizard from '~/javascript/components/onboardings/wizard.vue'

export default class extends Controller {
  static values = {
    businessId: String,
    onboardingId: String
  }

  connect() {
    this.vue = createApp(Wizard, {
      mode: 'internal',
      businessId: this.businessIdValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
